'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkflowCustomPlaceAutocomplete = function WorkflowCustomPlaceAutocomplete(_ref) {
    var component = _ref.component,
        returnProp = _ref.return,
        doSetReturn = _ref.doSetReturn,
        context = _ref.context;

    var handleOptionSelect = function handleOptionSelect(option) {
        doSetReturn({ componentCode: component.code, code: 'Value', value: option.placeId });
    };

    return _react2.default.createElement(_metrixCommon.CustomPlaceAutocomplete, { selectedOption: (0, _metrixCommon.getReturnElementByCode)(returnProp, 'Value'),
        code: (0, _metrixCommon.getElementValueByCode)(component.elements, 'QueryCode'),
        placeholder: (0, _metrixCommon.getElementValueByCode)(component.elements, 'Placeholder'),
        label: (0, _metrixCommon.getElementValueByCode)(component.elements, 'Label'),
        context: context,
        handleOptionSelect: handleOptionSelect
    });
};

WorkflowCustomPlaceAutocomplete.propTypes = {
    component: _propTypes2.default.object.isRequired,
    return: _propTypes2.default.object,
    doSetReturn: _propTypes2.default.func.isRequired,
    context: _propTypes2.default.object.isRequired
};

exports.default = WorkflowCustomPlaceAutocomplete;